import { Injectable } from '@angular/core';
import { AjaxDataServiceService } from '@admin/core/ajax-data-service.service';
import { UrlConfigContainer } from '@admin/core/url-config';
import { UrlConfigService } from '@hrra/core';
import { PagingFilter } from '../../../shared/models/paging-filter.model';
import { CvBoxAccessTokenFilterModel } from '../models/cv-box-access-token-filter-model';
import { CvBoxAccessTokenModel } from '../models/cv-box-access-token-model';
import { Observable } from 'rxjs';
import { PagingWrapper } from '../../../core/models/paging-wrapper';
import { CvBoxRequestActionData } from '../models/cv-box-request-action-data';
import { CvBoxRequestAction } from '../models/cv-box-request-action.enum';
import { EmptyData } from '../../../core/models/empty-data';

@Injectable({
  providedIn: 'root',
})
export class CvBoxProductServiceService {
  constructor(
    private ajax: AjaxDataServiceService,
    private urlService: UrlConfigService<UrlConfigContainer>
  ) {}

  public listCvBoxRequests(
    filter: PagingFilter<CvBoxAccessTokenFilterModel>
  ): Observable<PagingWrapper<CvBoxAccessTokenModel>> {
    const url = this.urlService.urlConfig.api.data.productPurchases.cvbox.request.list;
    return this.ajax.postDataPaging(
      url,
      filter.toObject(),
      CvBoxAccessTokenModel
    );
  }

  public approveCvBoxRequest(request: CvBoxAccessTokenModel) {
    const data = <CvBoxRequestActionData>{
      action: CvBoxRequestAction.Approve,
      cvBoxAccessTokenId: request.cvBoxAccessTokenId,
    };

    const url = this.urlService.format(
      this.urlService.urlConfig.api.data.productPurchases.cvbox.request.process,
      { id: request.cvBoxAccessTokenId }
    );
    return this.ajax.postData(url, data, EmptyData);
  }

  public rejectCvBoxRequest(request: CvBoxAccessTokenModel) {
    const data = <CvBoxRequestActionData>{
      action: CvBoxRequestAction.Reject,
      cvBoxAccessTokenId: request.cvBoxAccessTokenId,
    };
    const url = this.urlService.format(
      this.urlService.urlConfig.api.data.productPurchases.cvbox.request.process,
      { id: request.cvBoxAccessTokenId }
    );

    return this.ajax.postData(url, data, EmptyData);
  }

  public revokeCvBoxRequest(
    cvBoxAccessTokenId: number,
    affectBilling: boolean
  ) {
    const data = <CvBoxRequestActionData>{
      action: CvBoxRequestAction.Revoke,
      cvBoxAccessTokenId: cvBoxAccessTokenId,
      affectBilling: affectBilling,
    };
    const url = this.urlService.format(
      this.urlService.urlConfig.api.data.productPurchases.cvbox.request.process,
      { id: cvBoxAccessTokenId }
    );

    return this.ajax.postData(url, data, EmptyData);
  }

  public approveCvBoxRequestWithModification(
    request: CvBoxAccessTokenModel,
    newStoreItemId
  ) {
    const data = <CvBoxRequestActionData>{
      action: CvBoxRequestAction.ApproveWithModification,
      cvBoxAccessTokenId: request.cvBoxAccessTokenId,
      newStoreItemId: newStoreItemId,
    };
    const url = this.urlService.format(
      this.urlService.urlConfig.api.data.productPurchases.cvbox.request.process,
      { id: request.cvBoxAccessTokenId }
    );

    return this.ajax.postData(url, data, EmptyData);
  }
}
